import { Flex, Text, VStack } from '@chakra-ui/react';
import { Avatar } from '@halo/ui-chat-react';

interface Props {
  avatar: string;
  first_name: string;
  last_name: string;
  username: string;
}
const User = (props: Props) => {
  const { avatar, first_name, last_name, username } = props;
  return (
    <Flex align="center" gap="2" p="3" w="full" overflow="hidden">
      <Avatar src={avatar} />
      <VStack gap="1" align="flex-start" overflow="hidden">
        <Text w="full" lineHeight="1" fontSize="sm" color="fg" fontWeight="bold" truncate>
          {first_name} {last_name && `${last_name}`}
        </Text>
        <Text w="full" lineHeight="1" fontSize="xs" color="fg.muted" truncate>
          @{username}
        </Text>
      </VStack>
    </Flex>
  );
};
const MemoizedUser = memo(User);
export { MemoizedUser as User };
